<template>
  <b-form-group
    label="Parametre Alt Grubu"
    label-for="param_sub_groups"
  >
    <validation-provider
      #default="{ errors }"
      name="Parametre Alt Grubu"
      rules="required"
    >
      <b-form-input
        id="param_sub_groups"
        v-model="dataItem.param_sub_groups"
        placeholder="Parametre Alt Grubu"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup, BFormInput,
} from 'bootstrap-vue'
import { required } from '@validations'

export default {
  name: 'ParamsSubGroup',
  components: {
    BFormGroup,
    BFormInput,
    ValidationProvider,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['params/dataItem']
    },
  },
  created() {
    localize('tr')
  },
}
</script>

<style scoped>

</style>
